import React, {Component} from "react";
import config from 'react-global-configuration';
import { Redirect } from 'react-router';
import $ from "jquery";
import ReactTooltip from 'react-tooltip';
import {confirmAlert} from "react-confirm-alert";
import axios from "axios";
import jwt_decode from "jwt-decode";
import * as moment from "moment";
import Switch from "react-switch";
import {BeatLoader} from 'react-spinners';
import {css} from '@emotion/core';
import {Link} from "react-router-dom";
import {connect}  from  "react-redux";

const token = localStorage.usertoken;
const override = css`
    display: block;
    border-color: red;
    text-align: center;
`;
let decoded;
if (token != null) {
    decoded = jwt_decode(token);
}
class DashboardList extends Component {

    state = {
        dList: [],
        approve:[],
        group_id:'',
        loading:true,
        show_table: false,
        is_redirect: false,
        rediret_url:''
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {

        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });

        console.log(decoded.object_type);
        console.log(decoded);
        this.setState({
            user_id:decoded._id,
            subgroup_id: decoded.userSubGroup,
            subgroup_name: decoded.userSubGroupName

        });
       // console.log(decoded);
        this.get_dashboards(decoded);
    }
    get_dashboards(decoded){
        var arrayCode = decoded.object_code.split(",");
        var saf_dash = ['Innoviti','ISAP0339','ISAP0386','I03004','I03626','I03627','I02982']
        this.setState({
            loading:true
        })
        if ($.fn.DataTable.isDataTable('#dashboard_table')) {
            $('#dashboard_table').DataTable().destroy();
            //$('#mdata').html('');
        }
        axios.get(config.get('API_URL') + '/reportdashboard/getDashboardList/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                SubgroupId: decoded.userSubGroup
            }
        }).then(response => {
            var listData = response.data
            listData.map((rd, index) => {
                if(rd.dashbordName.display_name==="Sapphire Foods") {
                    const found = saf_dash.some(r=> arrayCode.includes(r))

                    if(found===false) {
                        listData.splice(index, 1);
                    }
                }
            });
            // console.log("mmmmmmmmmmmmmmmmmmmm");
            // console.log(decoded.object_code);
            // console.log(listData);

                if(listData.length==1){
                var rediret = '/admin/DashboardDetails?dashId=' + listData[0].dashboard_id;
                this.setState({
                    is_redirect: true,
                    rediret_url: rediret
                })
            }
            else if(listData.length>1){
                this.setState({
                    show_table: true
                })
            }
            listData.map((val, index)=>{
                this.setState({
                    approve: {...this.state.approve, [index]:val.dashbordName.isactive }
                })
            })

            this.setState({
                dList: listData,
                loading:false
            })

            $('#dashboard_table').dataTable();
        });
    }
    handleChangeStatusNo(id, checked,index){
        let sta
        if(checked===true) {
            sta = false
        } else {
            sta = true
        }

        this.setState({
            approve: {...this.state.approve, [index]:sta }
        })
    }
    handleChangeStatus(id, checked, index){
        axios.get(config.get('API_URL') + '/reportdashboard/change_status/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                id: id,
                checked: checked
             }
        }).then(response => {
            this.get_dashboards();
        });
    }
    changeStatus(index, id, checked) {
        let status = '';
        if(checked===true){ status = "Activate" } else { status = "Deactivate" }
        this.setState({
            approve: {...this.state.approve, [index]:checked }
        })
        confirmAlert({
            title: 'Question',
            message: 'Are you sure you want to '+status+' this Dashboard?.',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.handleChangeStatus(id,checked,index);
                }
            },
                {
                    label: 'No',
                    onClick: () => {
                        this.handleChangeStatusNo(id,checked,index);
                    }
                }

            ]
        });
    }

    deleteDashboard(id) {
        confirmAlert({
            title: 'Question',
            message: 'Are you sure you want to delete this Dashboard?.',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.handleClickDelete(id);
                }
            },
                {
                    label: 'No',
                }
            ]
        });
    }

    handleClickDelete(id) {
        axios.get(config.get('API_URL') + '/reportdashboard/delete_dashboard/' + id, {
            headers: {
                Authorization: `${localStorage.usertoken}`
            }
        }).then(response => {
            this.get_dashboards();
            //this.props.handleClick("tr", 1, "Dashboard has been successfully Deleted.");
        })
    }
    render() {
        if(this.state.subgroup_name === 'BVP Dashboard'){
            return (<Redirect to="/admin/bvp-dashboard" />);
        }
        if(this.state.is_redirect === true){
            return (<Redirect to={this.state.rediret_url} />);
        }
        const dListBind = this.state.dList.map((data, index) => {
            let link = "";
            let addcls = "";
            if(data.dashbordName.isactive===true) {
                if(data.dashbordName.display_name==="Sapphire Foods")
                {
                    link = "/admin/SapphireFoodDownloadReport";
                    addcls = "btn btn-default actionBtn";
                }
                else if(data.dashbordName.display_name==="BVP Dashboard")
                {
                    link = "/admin/bvp-dashboard";
                    addcls = "btn btn-default actionBtn";
                }
                else {
                    link = "/admin/DashboardDetails?dashId=" + data.dashboard_id;
                    addcls = "btn btn-default actionBtn";
                }
            }
            else {
                link = "#";
                addcls = "btn btn-default actionBtn isDisabled";
            }



    return (
        <tr key={index}>
            <td>{index + 1}</td>
            <td>{data.dashbordName.display_name}</td>
            <td>{moment(data.dashbordName.data_updated_at).format('D MMM YYYY HH:mm:ss')}</td>
            <td>{data.dashbordName.updated_by}</td>
            <td>
                <Link className={addcls}   to={link} data-tip="View Dashboard"><i className="fa fa-eye" aria-hidden="true"></i></Link>

                &nbsp;
                {this.state.subgroup_id==1?
                    <React.Fragment>
                        <a href="#" data-tip="Delete" className="btn btn-default actionBtn btn-delet" role="button"
                           onClick={this.deleteDashboard.bind(this,data.id)}> <span
                            className="glyphicon glyphicon-remove" aria-hidden="true"></span></a>
                        &nbsp;  &nbsp;
                        <Switch className="react-switch" height={18} width={38} onChange={this.changeStatus.bind(this,index,data.dashboard_id)} checked={(this.state.approve[index])? true : false} />
                    </React.Fragment>
                    :null }

            </td>
        </tr>
    )


        });

        return (

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div>
                                <div className="col-md-12 no-padd">
                                    <div className="card title-card-bottom-space">
                                        <div className="header">
                                            <h4 className="title">Dashboard List</h4>
                                            <p className="category"></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="clearfix"></div>
                                <div className="content bgcolor">
                                    <div className="row">
                                        <div className="col-lg-12 ">
                                            {this.state.show_table===true?
                                            <table id="dashboard_table" className="table table-striped table-hover">
                                                <thead>
                                                <tr>
                                                    <th>id</th>
                                                    <th>Dashboard Name</th>
                                                    <th>Date</th>
                                                    <th>Updated By</th>
                                                    <th>Actions</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    {dListBind}
                                                </tbody>
                                            </table> : null }
                                            <BeatLoader
                                                css={override}
                                                sizeUnit={"px"}
                                                size={20}
                                                color={'#123abc'}
                                                loading={this.state.loading}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="clearfix"></div>

                                <div className="footer">
                                    <div className="stats"><i></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( DashboardList);